import { render, staticRenderFns } from "./Product2.vue?vue&type=template&id=0de4f06b&scoped=true"
import script from "./Product2.vue?vue&type=script&lang=js"
export * from "./Product2.vue?vue&type=script&lang=js"
import style0 from "./Product2.vue?vue&type=style&index=0&id=0de4f06b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de4f06b",
  null
  
)

export default component.exports